import { render, staticRenderFns } from "./ClockSectionActions.vue?vue&type=template&id=4f22b154&scoped=true&"
import script from "./ClockSectionActions.vue?vue&type=script&lang=js&"
export * from "./ClockSectionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f22b154",
  null
  
)

export default component.exports